import axios from 'axios';
import { alert } from '@/js/composables/useModals.ts';

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response) {
            throw error;
        }
        if (error.response.status === 422) {
            if (error.response.data && error.response.data.errors) {
                const errors = Object.values(error.response.data.errors).join('\n');
                alert({
                    title: 'Error',
                    message: errors,
                });
                return Promise.reject(error);
            }
            if (error.response.data?.message) {
                alert({
                    title: 'Error',
                    message: error.response.data.message,
                });
                return Promise.reject(error);
            }
        } else if (error.response.status === 500) {
            alert({
                title: 'Internal Server Error',
                message:
                    "An internal server error has occurred and we're unable to process your request. We have been automatically notified of this error.",
            });
            return Promise.reject(error);
        } else if (error.response.status === 403) {
            alert({
                title: 'Forbidden',
                message: error.response.data.message,
            });
            return Promise.reject(error);
        } else if (error.response.status === 429) {
            alert({
                title: 'Too Many Requests',
                message: 'Please wait a moment before trying again.',
            });
            return Promise.reject(error);
        }
        throw error;
    }
);

export { axios };
